import { useEffect, useState } from "react";
import { getCalculatedDays, getFormattedCountdown } from "../utility";

/**
 * @description hook which takes in a date after today and continuously calculates how much
 * time is left until that date is reached. Time is broken down to days, hours, minutes and
 * seconds for use in a count down.
 * @param {object} params
 * @param {string} params.targetDate
 * @param {boolean} [params.shouldDisplaySecondsWhenDaysAreLeft]
 * @returns {object} days, hours, minutes and seconds
 */
const useCountdown = ({
    targetDate,
    shouldDisplaySecondsWhenDaysAreLeft = true,
}) => {
    const countdownDate = new Date(targetDate).getTime();

    const [countdown, setCountdown] = useState(
        countdownDate - new Date().getTime(),
    );

    useEffect(() => {
        // Exit early if we have reached the date
        if (countdown < 0) {
            return () => {};
        }
        // No need for this to run every second when seconds are not being shown.  Once we are down
        // to 0 days the count will run every second
        const days = getCalculatedDays(countdown);
        const delay =
            (!shouldDisplaySecondsWhenDaysAreLeft && days <= 0) ||
            shouldDisplaySecondsWhenDaysAreLeft
                ? 1000
                : 60000;

        const interval = setInterval(() => {
            setCountdown(countdownDate - new Date().getTime());
        }, delay);

        return () => clearInterval(interval);
    }, [countdownDate, countdown, shouldDisplaySecondsWhenDaysAreLeft]);

    return getFormattedCountdown(countdown);
};

export default useCountdown;
